import { render, staticRenderFns } from "./UsePage.vue?vue&type=template&id=1c10c8ee&scoped=true"
import script from "./UsePage.vue?vue&type=script&lang=js"
export * from "./UsePage.vue?vue&type=script&lang=js"
import style0 from "./UsePage.vue?vue&type=style&index=0&id=1c10c8ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c10c8ee",
  null
  
)

export default component.exports